export default function spin(spinner) {
    let d = spinner.width = spinner.height = 40,
        ctx = spinner.getContext('2d'),
        opacity;

    ctx.translate(d/2, d/2);
    ctx.rotate(Math.PI * 360/360);
    ctx.lineWidth = Math.ceil(d / 50);
    ctx.lineCap = 'square';

    for(var i=0; i<=360; i++) {
        ctx.save();

        ctx.rotate((Math.PI * i/180));

        ctx.beginPath();
        ctx.moveTo(0, 0);
        opacity = (360 - (i * 0.95)) / 360;
        ctx.strokeStyle = 'rgba(255,255,255,' + opacity.toFixed(2) +')';
        ctx.lineTo(0, d + 30);
        ctx.stroke();
        ctx.closePath();

        ctx.restore();
    }

    ctx.globalCompositeOperation ='source-out';
    ctx.beginPath();
    ctx.arc(0, 0, d/2, 2 * Math.PI, false);
    ctx.fillStyle = '#ff007a';
    ctx.fill();

    ctx.globalCompositeOperation ='destination-out';
    ctx.beginPath();
    ctx.arc(0, 0, (d/2) * .9, 2 * Math.PI, false);
    ctx.fill();
};
